<template>
  <div class="offline-meeting-history-template" theme>
    <div id="offline-meeting-history-content" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      path: 'offline-meeting',
      parts: [
        {
          elem: '#offline-meeting-history-content',
          htmlFile: 'history'
        }
      ]
    }
  }
}
</script>
